/**
 * @generated SignedSource<<d22cb2c4ffab26b7f71fc780a288d285>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v6 = {
  "kind": "Variable",
  "name": "legalContractId",
  "variableName": "id"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "valueType",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayOrder",
  "storageKey": null
},
v10 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastModifiedTimestampUtc",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v15 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "userName",
    "storageKey": null
  },
  (v2/*: any*/)
],
v16 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "IdentifierType",
    "kind": "LinkedField",
    "name": "identifierType",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      (v2/*: any*/)
    ],
    "storageKey": null
  },
  (v14/*: any*/),
  (v2/*: any*/)
],
v17 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "displayName",
    "storageKey": null
  },
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContractDetailsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Network",
                "kind": "LinkedField",
                "name": "network",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LineOfService",
                    "kind": "LinkedField",
                    "name": "linesOfService",
                    "plural": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "LinesOfServiceFragments_LineOfServiceDropdown"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ContractInfo_Contract"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Attachment",
                "kind": "LinkedField",
                "name": "attachments",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "Attachments"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "DataImporter_Attachments"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LegalContractLineOfService",
                "kind": "LinkedField",
                "name": "linesOfService",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ContractLinesOfServiceFragments_LinesOfService"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LegalContractTerm",
                "kind": "LinkedField",
                "name": "terms",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ContractTerms_Terms"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RosterLoad",
                "kind": "LinkedField",
                "name": "rosterLoads",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "RosterLoadTable_RosterLoad"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Note",
                "kind": "LinkedField",
                "name": "notes",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "Notes"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingGroup",
                "kind": "LinkedField",
                "name": "billingGroups",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ContractBillingGroups_BillingGroups"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Facility",
                "kind": "LinkedField",
                "name": "facilities",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ContractFacilities_Facilities"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "LegalContract",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": [
          (v6/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "ContractPractitionersTableFragment"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "allOrganizations",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "OrganizationsFragments_AllOrganizationsDropdown"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Network",
        "kind": "LinkedField",
        "name": "allNetworks",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NetworkFragments_allNetworkDropdown"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TermType",
        "kind": "LinkedField",
        "name": "allTermTypes",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TermTypesFragments_TermTypeDropdown"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AttachmentCategory",
        "kind": "LinkedField",
        "name": "allAttachmentCategories",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v9/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Fragments_AllAttachmentCategoriesDropdown"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContractDetailsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Network",
                "kind": "LinkedField",
                "name": "network",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LineOfService",
                    "kind": "LinkedField",
                    "name": "linesOfService",
                    "plural": true,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organization",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Attachment",
                "kind": "LinkedField",
                "name": "attachments",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "size",
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "downloadUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AttachmentCategory",
                    "kind": "LinkedField",
                    "name": "category",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LegalContractLineOfService",
                "kind": "LinkedField",
                "name": "linesOfService",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LineOfService",
                    "kind": "LinkedField",
                    "name": "lineOfService",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "otherServicesDiscountPercentage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "percentageOfBase",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isComplex",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "effectiveFrom",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "effectiveTo",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LegalContractTerm",
                "kind": "LinkedField",
                "name": "terms",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TermType",
                    "kind": "LinkedField",
                    "name": "type",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RosterLoad",
                "kind": "LinkedField",
                "name": "rosterLoads",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": (v15/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Note",
                "kind": "LinkedField",
                "name": "notes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "content",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "createdByUser",
                    "plural": false,
                    "selections": (v15/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "lastModifiedByUser",
                    "plural": false,
                    "selections": (v15/*: any*/),
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdTimestampUtc",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingGroup",
                "kind": "LinkedField",
                "name": "billingGroups",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BillingGroupIdentifier",
                    "kind": "LinkedField",
                    "name": "identifiers",
                    "plural": true,
                    "selections": (v16/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Facility",
                "kind": "LinkedField",
                "name": "facilities",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacilityVersion",
                    "kind": "LinkedField",
                    "name": "applicableVersion",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacilityIdentifier",
                    "kind": "LinkedField",
                    "name": "identifiers",
                    "plural": true,
                    "selections": (v16/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "LegalContract",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Literal",
                "name": "firstName",
                "value": null
              },
              {
                "kind": "Literal",
                "name": "lastName",
                "value": null
              },
              (v6/*: any*/),
              {
                "kind": "Literal",
                "name": "locationName",
                "value": null
              },
              {
                "kind": "Literal",
                "name": "npi",
                "value": null
              },
              {
                "kind": "Literal",
                "name": "tIN",
                "value": null
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "Practitioner",
        "kind": "LinkedField",
        "name": "filteredPractitioners",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PractitionerIdentifier",
            "kind": "LinkedField",
            "name": "identifiers",
            "plural": true,
            "selections": (v16/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PractitionerVersion",
            "kind": "LinkedField",
            "name": "applicableVersion",
            "plural": false,
            "selections": (v17/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "allOrganizations",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v11/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Network",
        "kind": "LinkedField",
        "name": "allNetworks",
        "plural": true,
        "selections": (v10/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TermType",
        "kind": "LinkedField",
        "name": "allTermTypes",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TermTypeCategory",
            "kind": "LinkedField",
            "name": "category",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AttachmentCategory",
        "kind": "LinkedField",
        "name": "allAttachmentCategories",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "be1961d5b88f4a2e9d69af4f867bc7ff",
    "id": null,
    "metadata": {},
    "name": "ContractDetailsQuery",
    "operationKind": "query",
    "text": "query ContractDetailsQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on LegalContract {\n      id\n      name\n      startDate\n      endDate\n      network {\n        id\n        linesOfService {\n          ...LinesOfServiceFragments_LineOfServiceDropdown\n          id\n        }\n      }\n      ...ContractInfo_Contract\n      attachments {\n        ...Attachments\n        ...DataImporter_Attachments\n        id\n      }\n      linesOfService {\n        ...ContractLinesOfServiceFragments_LinesOfService\n        id\n      }\n      terms {\n        ...ContractTerms_Terms\n        id\n      }\n      rosterLoads {\n        ...RosterLoadTable_RosterLoad\n        id\n      }\n      notes {\n        ...Notes\n        id\n      }\n      billingGroups {\n        ...ContractBillingGroups_BillingGroups\n        id\n      }\n      facilities {\n        ...ContractFacilities_Facilities\n        id\n      }\n    }\n    id\n  }\n  ...ContractPractitionersTableFragment_1260zN\n  allOrganizations {\n    ...OrganizationsFragments_AllOrganizationsDropdown\n    id\n  }\n  allNetworks {\n    ...NetworkFragments_allNetworkDropdown\n    id\n  }\n  allTermTypes {\n    id\n    description\n    valueType\n    ...TermTypesFragments_TermTypeDropdown\n  }\n  allAttachmentCategories {\n    id\n    name\n    displayOrder\n    ...Fragments_AllAttachmentCategoriesDropdown\n  }\n}\n\nfragment Attachments on Attachment {\n  id\n  fileName\n  size\n  lastModifiedTimestampUtc\n  downloadUrl\n  category {\n    id\n    name\n  }\n}\n\nfragment ContractBillingGroups_BillingGroups on BillingGroup {\n  id\n  name\n  identifiers {\n    identifierType {\n      code\n      id\n    }\n    value\n    id\n  }\n}\n\nfragment ContractFacilities_Facilities on Facility {\n  id\n  applicableVersion {\n    displayName\n    id\n  }\n  identifiers {\n    identifierType {\n      code\n      id\n    }\n    value\n    id\n  }\n}\n\nfragment ContractInfo_Contract on LegalContract {\n  id\n  name\n  startDate\n  endDate\n  network {\n    name\n    id\n  }\n  organization {\n    primaryName\n    id\n  }\n}\n\nfragment ContractLinesOfServiceFragments_LinesOfService on LegalContractLineOfService {\n  id\n  lineOfService {\n    id\n    name\n  }\n  otherServicesDiscountPercentage\n  percentageOfBase\n  isComplex\n  effectiveFrom\n  effectiveTo\n}\n\nfragment ContractPractitionersTableFragment_1260zN on Query {\n  filteredPractitioners(input: {legalContractId: $id}) {\n    id\n    identifiers {\n      identifierType {\n        code\n        id\n      }\n      value\n      id\n    }\n    applicableVersion {\n      displayName\n      id\n    }\n  }\n}\n\nfragment ContractTerms_Terms on LegalContractTerm {\n  id\n  type {\n    id\n    description\n    valueType\n  }\n  value\n}\n\nfragment DataImporter_Attachments on Attachment {\n  id\n  fileName\n  size\n  lastModifiedTimestampUtc\n  downloadUrl\n  category {\n    id\n    name\n  }\n}\n\nfragment Fragments_AllAttachmentCategoriesDropdown on AttachmentCategory {\n  id\n  name\n  displayOrder\n}\n\nfragment LinesOfServiceFragments_LineOfServiceDropdown on LineOfService {\n  id\n  name\n}\n\nfragment NetworkFragments_allNetworkDropdown on Network {\n  id\n  name\n}\n\nfragment Notes on Note {\n  id\n  content\n  createdByUser {\n    userName\n    id\n  }\n  lastModifiedByUser {\n    userName\n    id\n  }\n  lastModifiedTimestampUtc\n  createdTimestampUtc\n}\n\nfragment OrganizationsFragments_AllOrganizationsDropdown on Organization {\n  id\n  primaryName\n}\n\nfragment RosterLoadTable_RosterLoad on RosterLoad {\n  id\n  fileName\n  createdBy {\n    userName\n    id\n  }\n  createdOn\n  status\n}\n\nfragment TermTypesFragments_TermTypeDropdown on TermType {\n  id\n  description\n  displayOrder\n  category {\n    displayOrder\n    id\n  }\n}\n"
  }
};
})();

node.hash = "67a73854ffb65262ebfb8dc32af1dbfb";

export default node;
